import request from '../request'

export default {
  getGuards(parameter) {
    return request({
      url: 'stadium/guards',
      method: 'get',
      data: {
        query: parameter,
      },
    })
  },
}
